/** @format */

import React from 'react';

const line = (key, width, height = 12) => (
  <div
    key={key}
    style={{
      width,
      height,
      borderRadius: 4,
      background: '#E3E3E3',
    }}
  />
);

export default function PageLoadingSkeleton() {
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  const heading = path.includes("myProducts")
    ? "My Products"
    : path.includes("MyOrders") || path.includes("myOrders")
      ? "My Orders"
      : path.includes("setting")
        ? "Settings"
        : "Loading";

  return (
    <div
      aria-busy="true"
      aria-label="Loading"
      style={{
        minHeight: '100vh',
        width: '100%',
        background: '#F6F6F7',
        padding: '24px',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <h1 style={{ margin: '0 0 8px', fontSize: 24, lineHeight: '32px', fontWeight: 650 }}>{heading}</h1>
        <p style={{ margin: '0 0 20px', maxWidth: 640, fontSize: 14, lineHeight: '20px', color: '#616161' }}>
          Loading your store data. This page will fill in as soon as it is ready.
        </p>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, marginBottom: 20, flexWrap: 'wrap' }}>
          <div style={{ minWidth: 220, flex: '1 1 280px' }}>
            {line('title', 'min(360px, 80%)', 28)}
            <div style={{ height: 12 }} />
            {line('subtitle', 'min(520px, 100%)')}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            {line('action-1', 96, 32)}
            {line('action-2', 120, 32)}
          </div>
        </div>

        <div
          style={{
            background: '#FFFFFF',
            border: '1px solid #E1E3E5',
            borderRadius: 8,
            padding: 20,
            boxShadow: '0 1px 0 rgba(0, 0, 0, 0.05)',
          }}
        >
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 16, marginBottom: 24 }}>
            {[0, 1, 2, 3].map((item) => (
              <div key={item} style={{ display: 'grid', gap: 10 }}>
                {line(`metric-${item}-label`, '64%')}
                {line(`metric-${item}-value`, '46%', 22)}
              </div>
            ))}
          </div>

          <div style={{ display: 'grid', gap: 12 }}>
            {line('row-1', '100%')}
            {line('row-2', '92%')}
            {line('row-3', '78%')}
            {line('row-4', '84%')}
          </div>
        </div>
      </div>
    </div>
  );
}
